import styled from "styled-components";

const DjzFailPageDisplay = styled.div`
  background: ${(p) => p.bgImg};
  background-size: cover;
  min-height: 100vh;
  .formPage {
    padding: 20px;
  }
  .formsLayout .header .logo {
    background: var(--navbarLogo) center center no-repeat;
    height: var(--loginLogoHeight);
    width: var(--loginLogoWidth);
    max-width: 350px;
    background-size: var(--background-size);
  }
  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    .message {
      margin-bottom: 20px;
      font-size: 1.1rem;
      color: #c0392b;
    }
    .btn {
      padding: 12px 24px;
      background: var(--primary-color, #65378b);
      color: white;
      text-decoration: none;
      border-radius: 4px;
      margin-bottom: 12px;
    }
    .btn-link {
      color: inherit;
      text-decoration: underline;
    }
  }
`;

export default DjzFailPageDisplay;
